import { render, staticRenderFns } from "./TaxonNestedListItem.vue?vue&type=template&id=ede5783e"
import script from "./TaxonNestedListItem.vue?vue&type=script&lang=js"
export * from "./TaxonNestedListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports